import { Next, select, takeEvery, ThunkCtx } from "starfx";

import { EComponentStack } from "@app/state/constants";
import { keyValFrom } from "@app/statefx/helpers/resultUtils";

import { schema } from "../schema";
import { xThunk } from "../xapis";

type TPaneState = { [key in EComponentStack]: number[] };
export const fxResizeAllotment = xThunk.create<TPaneState>(
  "fxResizeAllotment",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const [key, value] = keyValFrom(ctx.payload);
    yield* schema.update(schema.uiAllotment.update({ key, value }));
    yield* next();
  }
);

export type TPaneCollapsedState = { [key in EComponentStack]: boolean };
export const fxCollapsedAllotmentStates = xThunk.create<TPaneCollapsedState>(
  "fxCollapsedAllotmentStates",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const ds = yield* select(schema.uiAllotmentCollapsed.select);
    const newState = { ...ds, ...ctx.payload };
    yield* schema.update(schema.uiAllotmentCollapsed.set(newState));
    yield* next();
  }
);
